"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var BANK_ACCOUNT_NUMBER_REGEXP = /^\d{3,16}$/;
function formatAccountNumber(value) {
    return value.replace(new RegExp('[- .,]', 'g'), ''); // Remove hyphen, blank space, period and comma.
}
exports.formatAccountNumber = formatAccountNumber;
exports.bankAccountNumberValidator = {
    name: 'bankAccountNumber',
    validation: function (value) {
        return utils_1.isEmpty(value) || BANK_ACCOUNT_NUMBER_REGEXP.test(formatAccountNumber(value));
    },
};
//# sourceMappingURL=BankAccountNumberValidator.js.map